import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminPartsTasks = lazy(() => import("@/pages/admin/AdminPartsTasks"));

function AdminPartsTasksRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <AdminPartsTasks />
    </Suspense>
  );
}

export const Route = createFileRoute("/_adminLayout/admin/parts/tasks")({
  component: AdminPartsTasksRoute,
});
